import React, { Component } from 'react';
import { connect } from 'react-redux';

import Locale from '../data/localization';
import { nodes } from '../data/data';
import * as objectTypes from '../constants/objectTypes';
import config from '../data/config';

import View from '../components/View';
import ViewContainer from '../components/ViewContainer';
import Place from '../components/Place';

import { show as showMap, changeAccessibility } from '../actions/map';

class StartView extends Component {

    handleSubmit(event) {
        const { map, nodes } = this.props

        const avoid = Object.keys(nodes)
            .filter(key => {
                if (nodes[key].type === objectTypes.ENTRANCE) {
                    return true
                }

                if (map.accessible) {
                    if (nodes[key].type === objectTypes.STAIRS || nodes[key].type === objectTypes.ESCALATOR) {
                        return true
                    }
                }

                if (nodes[key].type === objectTypes.SHOP || (nodes[key].shopId && nodes[nodes[key].shopId] && nodes[nodes[key].shopId].type === objectTypes.SHOP)) {
                    return true
                }

                return false
            })
            .filter(key => key !== map.from && key !== map.to && nodes[key].shopId !== map.from && nodes[key].shopId !== map.to)

        const options = {
            from: map.from in nodes && nodes[map.from].uid || map.from,
            to: map.to in nodes && nodes[map.to].uid || map.to
        }

        this.props.dispatch(showMap(map.from, map.to, avoid, options))
    }

    handleAccessibilityChange(event) {
        this.props.dispatch(changeAccessibility(event.target.checked))
    }

    render() {
        const { map, search, nodes, dispatch } = this.props;
        const from = map.from in nodes ? { ...nodes[map.from] } : { name: '' };
        const to = map.to in nodes ? { ...nodes[map.to] } : { name: '' }
        const isDisabled = !(map.from && map.to) || map.from === map.to

        return (
            <View type="StartView">
                <ViewContainer>
                    <img src={`${config.basePath}/assets/frontend/img/logo-palladium.svg`} width="104" height="63" alt="" className="Logo" />
                    <Place label={Locale.place.location.label} value={from.name} type="location" dispatch={dispatch} />
                    <Place label={Locale.place.target.label} value={to.name} type="target" dispatch={dispatch} />
                    <div className="Accessible">
                        <label>
                            <input type="checkbox" className="Checkbox" onChange={::this.handleAccessibilityChange} /> {Locale.place.accesibility}
                        </label>
                    </div>
                    <button type="button" className="Button Button--primary Button--full" disabled={isDisabled} onClick={::this.handleSubmit}>{Locale.place.showMap}</button>
                </ViewContainer>
            </View>
        )
    }
}

function mapStateToProps(state) {
    return {
        map: state.ui.map,
        search: state.ui.search,
        nodes: state.entities.nodes
    }
}

export default connect(mapStateToProps)(StartView);


// WEBPACK FOOTER //
// ./containers/StartView.js